module.exports = __webpack_public_path__ + "static/img/1.09199676.svg";